import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPeople16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconPeople16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6 7a1.75 1.75 0 1 0 0-3.5A1.75 1.75 0 0 0 6 7m2.75-1.75c0 .832-.37 1.578-.954 2.082A5 5 0 0 1 11 12v1h2.696v-.74A3.35 3.35 0 0 0 11 8.978V7.62a1.391 1.391 0 0 0-1-2.577V4.025q.171-.024.348-.025a2.391 2.391 0 0 1 1.562 4.202 4.35 4.35 0 0 1 2.786 4.059V14H1v-2a5 5 0 0 1 3.204-4.668A2.75 2.75 0 1 1 8.75 5.25M6 13h4v-1a4 4 0 1 0-8 0v1z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPeople16);
